
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
:host svg.color-neutral circle {
  fill: var(--slh-color-neutral, #39455D);
}
:host svg.color-neutral stop {
  stop-color: var(--slh-color-neutral, #39455D);
}
:host svg.color-primary circle {
  fill: var(--slh-color-primary, #3B87D4);
}
:host svg.color-primary stop {
  stop-color: var(--slh-color-primary, #3B87D4);
}
:host svg.color-neutral-shade-80 circle {
  fill: var(--slh-color-neutral-shade-80, #4E5E7E);
}
:host svg.color-neutral-shade-80 stop {
  stop-color: var(--slh-color-neutral-shade-80, #4E5E7E);
}
:host svg.color-error circle {
  fill: var(--slh-color-error, #FF7E70);
}
:host svg.color-error stop {
  stop-color: var(--slh-color-error, #FF7E70);
}
`;
